import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Field, Asset } from '../../../core/store/models';
import { PDropdownOption } from '../../interfaces/p-dropdown-options';
import { buildPDropdownOptions } from '../../../core/store/utils';
import { SavingMessage, Severity } from '../../../core/store/types';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { take } from 'rxjs/operators';
import { UPDATE_LIMIT } from '../../../../../shared/constants/asset-limit.constant';
import { FIELD_TYPES } from '../../../../../shared/fields/field-types';
import pluralize from 'pluralize';
import { DeviceDetectorService } from 'ngx-device-detector';
export interface UpdateFieldModalData {
    assets: Asset[];
    bulkUpdate?: (models: Asset[], dialogRef: MatDialogRef<UpdateFieldModalComponent>) => void;
    fieldOptions: PDropdownOption[];
    fields: Field[];
    numOfDivisionAssets,
    numOfFranchiseAssets
}

@Component({
    templateUrl: './update-field-modal.component.html',
    styleUrls: ['./update-field-modal.component.scss'],
    standalone: false
})
export class UpdateFieldModalComponent implements OnInit {
    assets: Asset[];
    bulkUpdate?: (models: any, dialogRef: MatDialogRef<UpdateFieldModalComponent>, fieldValue?: any, overwrite?: boolean) => void;
    fieldOptions: PDropdownOption[];
    fields: Field[];
    saveDisabled = true;
    savingMessage: SavingMessage[] = [];
    selectedField: number;
    selectedValue: number;
    valueOptions: PDropdownOption[] = [];
    updateLimit = UPDATE_LIMIT;
    fieldType: string = FIELD_TYPES.PICKLIST.type;
    fieldTypes: any;
    fieldName: string;
    overwrite = false;
    isTextField = false;
    isMatched = false;
    needsSelect = true;
    field: Field;
    selectedOptions = [];

    constructor(@Inject(MAT_DIALOG_DATA) private data: UpdateFieldModalData, public dialog: MatDialog, public dialogRef: MatDialogRef<UpdateFieldModalComponent>, public deviceService: DeviceDetectorService) { }

    ngOnInit() {
        this.assets = this.data.assets;
        this.bulkUpdate = this.data.bulkUpdate;
        this.fields = this.data.fields;
        this.fieldOptions = this.data.fieldOptions;
        this.fieldTypes = FIELD_TYPES;
    }

    selectField(event) {
        this.selectedValue = null;
        this.overwrite = false;
        this.saveDisabled = true;
        this.needsSelect = event.value === null;
        if (event && event.value) {
            this.field = event.value ? this.fields.find(f => f.id === event.value) : null;

            this.fieldName = this.field.name;
            if (this.field && this.field.picklistOptions.length) {
                this.valueOptions = buildPDropdownOptions(this.field.picklistOptions, {
                    nullOption: true,
                    nullLabel: this.field.name
                });
            }
            this.fieldType = this.field.type;
            if (this.fieldType === this.fieldTypes.CHECKBOX.type) {
                this.valueOptions = [{ label: this.fieldName, value: null }, { label: 'True', value: true }, { label: 'False', value: false }]
            }
            this.isTextField = this.fieldType === this.fieldTypes.MULTI_PICKLIST.type || this.fieldType === this.fieldTypes.SHORT_TEXT_AREA.type || this.fieldType === this.fieldTypes.LONG_TEXT_AREA.type;
            this.overwrite = this.fieldType === this.fieldTypes.NUMBER.type || this.fieldType === this.fieldTypes.PICKLIST.type;
        } else {
            this.valueOptions = [];
            this.fieldType = this.fieldTypes.PICKLIST.type || this.fieldTypes.MULTI_PICKLIST.type;
            this.isTextField = false;
        }
        this.selectedOptions = [];
    }

    updateField(event: any) {
        if (this.fieldType === this.fieldTypes.CHECKBOX.type) {
            this.saveDisabled = (event.value === true || event.value === false) ? false : true;
        } else if (this.fieldType === this.fieldTypes.MULTI_PICKLIST.type) {
            this.saveDisabled = event?.length ? false : true;
            this.selectedValue = event?.length ? event : null;
        } else {
            this.saveDisabled = event.value || event.target.value ? false : true;
        }
        if (this.fieldType === this.fieldTypes.CURRENCY.type) {
            this.isMatched = event.target.value.match("^-?(?:\\d{1,15}(?:\\.\\d{0,3})?|\\.\\d{1,3})$") != null ? false : true;
        }
    }

    save() {
        this.savingMessage = [{ severity: Severity.Info, summary: 'Saving...' }];
        const field: Field = this.fields.find(f => f.id === this.selectedField);
        const newAssets = this.assets.map(a => ({ ...a, [field.canonical_name]: this.selectedValue ? this.selectedValue : null }));
        const deptIds = new Set(this.assets.map(a => a.department_id));
        const cheked = [...deptIds].every(deptId => field.departmentFields.find(df => df.department_id === deptId));
        let message = [`Updating ${newAssets.length} ${pluralize('asset', newAssets.length)} cannot be undone. Are you sure you want to continue?`];
        if (!cheked) {
            let assetUpdatdCount = 0;
            for (const a of newAssets) {
                const deptFieldExists = this.fields.find(f => f.id === field.id && f.departmentFields.find(df => field.id === df.field_id && df.department_id === a?.department_id))
                if (deptFieldExists) {
                    ++assetUpdatdCount;
                }
            }

            message.push(`${assetUpdatdCount} Asset${assetUpdatdCount > 1 ? 's' : ''} will be updated. The selected field will not be updated on all records because it is not supported in all departments.`);
        }
        if (field.type == "PICKLIST" || field.type == "CHECKBOX") {
            const fieldValue = {};
            this.overwrite = true;
            fieldValue[field.canonical_name] = this.selectedValue;
            this.bulkUpdate(newAssets, this.dialogRef, fieldValue, this.overwrite);
        } else {
            this.dialog.open(ConfirmModalComponent, {
                data: {
                    title: 'Warning',
                    charSetMessage: message,
                    confirmButton: 'Confirm',
                    confirmColor: 'warn',
                    cancelButton: 'Cancel'
                }
            }).afterClosed().pipe(take(1)).subscribe(save => {
                if (save) {
                    const fieldValue = {};
                    fieldValue[field.canonical_name] = this.selectedValue;
                    this.bulkUpdate(newAssets, this.dialogRef, fieldValue, this.overwrite);
                } else {
                    this.savingMessage = [];
                    return;
                }
            });
        }
    }
}
